module.exports = __webpack_public_path__ + "img/baidi.ea894170.png";